module.exports = __webpack_public_path__ + "static/media/Rate-our-integration-five-star.d024a07b.jpg";